import API from 'aurora-api';
// import * as endpoint from 'aurora-api/endpoints';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;
const apiUrl = new API(BASE_URL);
class AuthService {
  // guest user api
  static guestLogin = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append('grant_type', 'client_credentials');
    const token = Buffer.from(
      `${process.env.REACT_APP_GUEST_CLIENT_ID}:${process.env.REACT_APP_GUEST_CLIENT_SECRET}`,
      'utf8',
    ).toString('base64');

    const guestApi = new API(
      BASE_URL,
      token,
      {
        headers: { contentType: 'application/json' },
      },
      'Basic',
    );
    const res = await guestApi.post(urls.AUTH.GUEST_USER, bodyFormData);
    return res.access_token;
  };

  // login with eid and unified
  static login = async (data, authMode) => {
    let url = urls.AUTH.LOGIN_WITH_OTP;
    if (authMode === 'uaePass') {
      url = urls.AUTH.LOGIN_WITH_UAE_PASS;
    }

    if (authMode === 'email') {
      url = urls.AUTH.LOGIN_WITH_EMAIL;
    }
    const api = new API(
      BASE_URL,
      localStorage.getItem('access_token'),
      {
        headers: { contentType: 'application/json' },
      },
      'Bearer',
    );

    const res = await api.post(url, {
      ...data,
    });
    if (authMode === 'uaePass') {
      if (res?.data?.access_token || res?.access_token) {
        return res;
      }
    }
    return {
      pinId: res.pinId,
      mobileNumber: res.mobileNumber,
      userName: res.userName,
      emiratesID: res.emiratesID,
      unifiedNumber: res.unifiedNumber,
    };
  };

  // resend OTP
  static requestOTP = data => {
    let url = urls.AUTH.RESEND_OTP;
    if (localStorage.getItem('login_with') === 'uaePass') {
      url = urls.AUTH.RESEND_OTP_UAE_PASS;
    }

    const api = new API(
      BASE_URL,
      localStorage.getItem('access_token'),
      {
        headers: { contentType: 'application/json' },
      },
      'Bearer',
    );

    return api.post(`${url}/${data}`, {});
  };

  // verify OTP
  static verifyOTP = (data, authMode) => {
    let url = urls.AUTH.VERIFY_OTP;
    if (authMode === 'uaePass') {
      url = urls.AUTH.VERIFY_OTP_UAE_PASS;
    }
    if (localStorage.getItem('login_with') === 'email') {
      url = urls.AUTH.VERIFY_OTP_NON_UAE;
    }
    const api = new API(
      BASE_URL,
      localStorage.getItem('access_token'),
      {
        headers: { contentType: 'application/json' },
      },
      'Bearer',
    );
    return api.post(url, data);
  };

  static submitContactUs = data => {
    const api = new API(BASE_URL);
    return api.post(urls.AUTH.CONTACT_US, data);
  };

  static getMarketDataToken = async reportId => {
    const guestToken =
      localStorage.getItem('login_with') === 'GuestLogin'
        ? localStorage.getItem('access_token')
        : await this.guestLogin();
    const api = new API(
      BASE_URL,
      guestToken,
      {
        headers: { contentType: 'application/json' },
      },
      'Bearer',
    );
    const resp = api.post(urls.AUTH.MARKET_DATA_TOKEN, [reportId]);
    return resp;
  };

  static fetchInsuranceCompany = () => apiUrl.get(urls.AUTH.INSURANCE_COMPANY);

  static fetchEmiratesSource = () => apiUrl.get(urls.AUTH.EMIRATES_SOURCE);

  static fetchOffPlanProjects = (params = null) => apiUrl.get(urls.AUTH.FETCH_OFF_PLAN_PROJECTS, null, params);

  static fetchOffPlanUnitUsage = () => apiUrl.get(urls.AUTH.FETCH_OFF_PLAN_UNIT_USAGE);

  static fetchOffPlanLandUsage = () => apiUrl.get(urls.AUTH.FETCH_OFF_PLAN_LAND_USAGE);

  static fetchOffPlanUnitTypes = () => apiUrl.get(urls.AUTH.FETCH_OFF_PLAN_UNIT_TYPES);

  static fetchCertificateType = () => apiUrl.get(urls.AUTH.FETCH_CERTIFICATE_TYPES);

  static fetchPropertyProjects = () => apiUrl.get(urls.AUTH.FETCH_PROPERTY_PROJECTS);

  static verifyEmail = username => apiUrl.post(urls.AUTH.VERIFY_EMAIL, null, { username });

  static createPassword = body => apiUrl.post(urls.AUTH.CREATE_PASSWORD, body);

  static forgotPassword = email => apiUrl.post(urls.AUTH.FORGOT_PASSWORD, email);

  static resetPassword = body => apiUrl.post(urls.AUTH.RESET_PASSWORD, body);

  static verifyLink = email => apiUrl.post(urls.AUTH.VERIFY_LINK, { email });
}

export default AuthService;
